import { Injectable } from '@angular/core';

declare const bootstrap: any;

@Injectable({
  providedIn: 'root'
})
export class TooltipService {
  private tooltipInstances = new Map<string, any>();

  initializeTooltip(element: HTMLElement, options?: any): void {
    if (!element) return;

    // Check if bootstrap is available
    if (typeof bootstrap === 'undefined') {
      console.warn('Bootstrap is not available. Tooltips will not work.');
      return;
    }

    const elementId = element.id || `tooltip-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
    
    if (!element.id) {
      element.id = elementId;
    }

    // Dispose existing tooltip if it exists
    this.disposeTooltip(elementId);

    const defaultOptions = {
      trigger: 'hover',
      placement: 'top',
      ...options
    };

    try {
      const tooltip = new bootstrap.Tooltip(element, defaultOptions);
      this.tooltipInstances.set(elementId, tooltip);
    } catch (error) {
      console.error('Error initializing tooltip:', error);
    }
  }

  disposeTooltip(elementId: string): void {
    const tooltip = this.tooltipInstances.get(elementId);
    if (tooltip) {
      try {
        tooltip.dispose();
      } catch (error) {
        console.error('Error disposing tooltip:', error);
      }
      this.tooltipInstances.delete(elementId);
    }
  }

  disposeAllTooltips(): void {
    this.tooltipInstances.forEach((tooltip, elementId) => {
      try {
        tooltip.dispose();
      } catch (error) {
        console.error('Error disposing tooltip:', error);
      }
    });
    this.tooltipInstances.clear();
  }

  initializeAllTooltips(): void {
    // First dispose all existing tooltips to prevent duplicates
    this.disposeAllTooltips();
    
    const tooltipElements = document.querySelectorAll('[data-bs-toggle="tooltip"]');
    tooltipElements.forEach((element: any) => {
      // Only initialize if element is visible and in DOM
      if (element.offsetParent !== null || element.offsetWidth > 0 || element.offsetHeight > 0) {
        this.initializeTooltip(element);
      }
    });
  }
}